module.exports = __webpack_public_path__ + "static/media/barriers-header.d403f0f7.png";